import { uri } from '../utils/config';
import { HTTP } from './secure/http';

export const updateCategoryImage = async (placeId, categoryId, file) => {
  if (!placeId || !categoryId || !file) {
    console.log('NO PLACE ID');
    return;
  }
  let data = new FormData();
  data.append('file', file);

  await HTTP.post({
    path: `${uri.api}/place/${placeId}/category/${categoryId}/update/image`,
    data,
  });
};